import { createAsyncThunk } from "@reduxjs/toolkit";
import { APIMasteringProject } from "../../models/project";
import { makeBackendPostCallWithJsonResponse } from "../../utils/fetch";
import { ENGINEER_MASTER_PROJECT } from "../../utils/routes";
import { receiveErrors } from "../errorStore";
import { masteringTransitionParams } from "./types";

interface engineerMasteringTransition extends masteringTransitionParams {
  engineer_file_notes?: string;
  engineer_master_notes?: string;
  enable_artist_review_mp3_file_download?: boolean;
  enable_artist_review_wav_file_download?: boolean;
}

const engMasteringTransition = createAsyncThunk(
  ENGINEER_MASTER_PROJECT,
  async (args: engineerMasteringTransition, thunkAPI) => {
    const response =
      await makeBackendPostCallWithJsonResponse<APIMasteringProject>(
        ENGINEER_MASTER_PROJECT,
        args,
      );
    if (response.success) {
      return response.resultJson;
    }
    const errors = { errors: response.resultJson };
    thunkAPI.dispatch(receiveErrors(errors));
    return thunkAPI.rejectWithValue(errors);
  },
);

export default engMasteringTransition;
